/**
 * 新建向导：除「相册信息」首步外，其余页须已有相册 ID 才能保存/上传。
 * 首步 POST /albums 成功后把 id 写入 sessionStorage（非 localStorage），供 /albums/create/* 无 :id 路由读取。
 * 从向导外进入 /albums/create 时会由路由守卫 clearPendingCreateAlbumId，避免沿用旧草稿 id。
 */
export const PENDING_CREATE_ALBUM_ID_KEY = 'vue_photos_pending_create_album_id'

/** 统一提示：其它页在缺少相册 id 时使用 */
export const MSG_NEED_ALBUM_FIRST =
  '请先完成「相册信息」保存以创建相册，再继续本页操作。'

export function readPendingCreateAlbumId () {
  try {
    const raw = sessionStorage.getItem(PENDING_CREATE_ALBUM_ID_KEY)
    const n = Number(raw)
    return Number.isInteger(n) && n > 0 ? n : null
  } catch {
    return null
  }
}

export function writePendingCreateAlbumId (id) {
  const n = Number(id)
  if (!Number.isInteger(n) || n <= 0) return
  try {
    sessionStorage.setItem(PENDING_CREATE_ALBUM_ID_KEY, String(n))
  } catch {
    /* ignore */
  }
}

export function clearPendingCreateAlbumId () {
  try {
    sessionStorage.removeItem(PENDING_CREATE_ALBUM_ID_KEY)
  } catch {
    /* ignore */
  }
}
